import type { ProposalStatus } from "@gsp/shared";
import { PROPOSAL_STATUS_LABELS } from "@gsp/shared";

type Tone = "slate" | "green" | "amber" | "red" | "blue";

const dotTones: Record<Tone, string> = {
  slate: "bg-slate-400",
  green: "bg-emerald-500",
  amber: "bg-amber-500",
  red: "bg-red-500",
  blue: "bg-blue-500",
};

/** Dot + neutral-label status chip for line/proposal state machines — used
 * instead of a solid-fill Badge for statuses users track over time. */
export function StatusBadge({ tone, children }: { tone: Tone; children: React.ReactNode }) {
  return (
    <span className="inline-flex items-center gap-1.5 text-[11px] font-medium px-2 py-0.5 rounded-full bg-slate-100 text-slate-700 dark:bg-white/10 dark:text-slate-200 whitespace-nowrap">
      <span className={`h-1.5 w-1.5 rounded-full ${dotTones[tone]}`} />
      {children}
    </span>
  );
}

export function LineStatusBadge({ status }: { status: "unconfirmed" | "confirmed" }) {
  return <StatusBadge tone={status === "confirmed" ? "green" : "slate"}>{status === "confirmed" ? "Confirmed" : "UnConfirmed"}</StatusBadge>;
}

const proposalTones: Record<ProposalStatus, Tone> = {
  supplier_proposal: "amber",
  approved_with_change: "green",
  supplier_proposal_rejected: "red",
};

export function ProposalStatusBadge({ status }: { status: ProposalStatus }) {
  return <StatusBadge tone={proposalTones[status]}>{PROPOSAL_STATUS_LABELS[status]}</StatusBadge>;
}
